import { render, staticRenderFns } from "./AccountFranchisorDesktopMenu.vue?vue&type=template&id=6890f2b8&scoped=true&"
import script from "./AccountFranchisorDesktopMenu.vue?vue&type=script&lang=js&"
export * from "./AccountFranchisorDesktopMenu.vue?vue&type=script&lang=js&"
import style0 from "./AccountFranchisorDesktopMenu.vue?vue&type=style&index=0&id=6890f2b8&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6890f2b8",
  null
  
)

export default component.exports